import React from 'react';
import { message } from 'antd';
import { Icon } from '@/src/tools/icon';
import css from './css.module.less';

interface CopyTextProps {
  text: string;
  className?: string;
  successMsg?: string;
  otherText?: string;
}

export const CopyText: React.FC<CopyTextProps> = ({
  text,
  className,
  successMsg = 'Copied successfully!',
  otherText,
}) => {
  const copyToClip = async (value: string) => {
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      message.success(successMsg);
    } catch {
      message.error('Copy failed');
    }
  };

  return (
    <span className={`${css.copyText} ${className || ''}`}>
      {text} {otherText}{' '}
      <Icon
        type='iconfile-copy'
        className={css.icon}
        onClick={() => copyToClip(text)}
      />
    </span>
  );
};
